import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataFilterPipe } from './components/data-table/data-filter.pipe';
import { NgScrollbarModule, NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { ApexChartService } from './components/chart/apex-chart/apex-chart.service';
import { ShipBudgetChartComponent } from './components/chart/ship-budget-chart/ship-budget-chart.component';

const DEFAULT_SCROLLBAR_CONFIG = {
  track: 'vertical',
  visibility: 'hover',
  autoHeightDisabled: false
};

@NgModule({
  imports: [
    CommonModule,
    NgScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    NgClickOutsideDirective
  ],
  exports: [
    CommonModule,
    NgScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    DataFilterPipe,
    NgClickOutsideDirective,
    ShipBudgetChartComponent
  ],
  declarations: [
    DataFilterPipe,
    ShipBudgetChartComponent
  ],
  providers: [
    {
      provide: NG_SCROLLBAR_OPTIONS,
      useValue: DEFAULT_SCROLLBAR_CONFIG
    },
    ApexChartService
  ]
})
export class SharedModule { }
